import React, { useState, useRef } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CustomButton from "../CommonComp/Buttons/CustomButton";
import { useDropzone } from "react-dropzone";
import { ImageSearchAfterUpload } from "../../Services/legal";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

function ImageSearchModal({ open, handleOpen, handleLast }) {
  const [loading, setLoading] = useState(false);
  const [imageData, setImageData] = useState("");
  const [selectedImageData, setSelectedImageData] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const fileInputRef = useRef(null);

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles[0]) {
      setImageData(URL.createObjectURL(acceptedFiles[0]));
      let fileName = acceptedFiles[0].name.split(".");
      fileName = fileName[fileName.length - 1];
      let newFile = new File(
        [acceptedFiles[0]],
        `item.${fileName || "jpeg"}`,
        { type: acceptedFiles[0].type }
      );
      setSelectedImageData(newFile);
      handleSubmit(newFile);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleSubmit = async (file) => {
    try {
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append("uploaded_file", file);
        const data = await dispatch(ImageSearchAfterUpload(formData));
        if (data) {
          navigate(`?tab=3`);
          handleLast(imageData);
        }
        handleOpen(false);
        setLoading(false);
      }
    } catch (e) {
      console.log("Error:", e);
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setImageData("");
      setSelectedImageData("");
      handleOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            overflow: 'visible',
            paddingBottom: '30px',
          }
        }
      }}
    >
      <DialogTitle variant="h3" padding={3} style={{ textAlign: "center", fontSize: "24px", marginTop: "5px", paddingBottom: "0px" }}>
        Search by Image
      </DialogTitle>
      
      
      <div style={{ position: 'absolute', top: '-22px', right: '-17px', cursor: 'pointer', zIndex: 1 }} onClick={handleClose}>
        <svg width="12px" height="12px" viewBox="3 3 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9904 18.8238L18.8334 20L12 13.157L5.16661 19.9904L4.00955 18.8334L10.8429 12.0191L4.00956 5.17617L5.1666 4L12.0191 10.8429L18.8429 4.00956L19.9809 5.16661L13.1762 12L19.9904 18.8238Z" fill="#fff"></path>
        </svg>
      </div>

      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" marginTop={"10px"}>
          <div {...getRootProps()} style={{ width: '100%', cursor: 'default' }}>
            <input
              {...getInputProps()}
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept="image/*"
            />
            <Box
              sx={{
                border: '2px dashed #ccc',
                padding: '20px 24px 0px',
                textAlign: 'center',
                backgroundColor: isDragActive ? '#e3f2fd' : '#f4f4f4',
                transition: 'background-color 0.3s',
                width: '100%',
                height: '310px',
              }}
            >
              <svg width="108" height="95" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" class="qTvNo4Gm0aZJeeONxHfa"><g clip-path="url(#clip0_994_14916)"><path d="M7.82 77.37H0v-7.83h4.69v3.13h3.13v4.7zM4.69 59.65H0v-9.88h4.69v9.88zm0-19.77H0V30h4.69v9.88zM4.69 20.11H0v-7.82h7.82v4.69H4.69v3.13zM47.37 16.98h-9.89v-4.69h9.89v4.69zm-19.78 0h-9.88v-4.69h9.93l-.05 4.69z" fill="#666"></path><path d="M80.21 31.62H19.83V92h60.38V31.62z" fill="#A6A6A6"></path><path d="M80.22 75.28L61.4 56.45 42.29 75.56l-8.99-8.99-13.46 12.8V92h60.38V75.28zM40.83 55.23a6.26 6.26 0 100-12.52 6.26 6.26 0 000 12.52z" fill="#fff"></path><path d="M40.83 57.57a8.61 8.61 0 01-8.6-8.6 8.61 8.61 0 018.6-8.6 8.61 8.61 0 018.6 8.6 8.61 8.61 0 01-8.6 8.6zm0-12.51a3.91 3.91 0 100 7.82 3.91 3.91 0 000-7.82z" fill="#666"></path><path d="M80.22 52.84c13.945 0 25.25-11.305 25.25-25.25S94.165 2.34 80.22 2.34 54.97 13.645 54.97 27.59s11.305 25.25 25.25 25.25z" fill="#fff"></path><path d="M107.81 27.59A27.632 27.632 0 0080.22 0a27.63 27.63 0 00-27.6 27.59c0 .57 0 1.12.09 1.68H17.49v65.07h65.07V55.07a27.63 27.63 0 0025.25-27.48zM77.87 89.65H22.18v-9.27l11.08-10.53 9 9 19.1-19.11 16.48 16.48.03 13.43zM61.39 53.13l-19.1 19.11-9-9-11.16 10.61V33.91h31.22a27.63 27.63 0 0024.47 21.11v14.54L61.39 53.13zm18.83-2.64a22.92 22.92 0 01-22.9-22.9 22.93 22.93 0 0122.9-22.9 22.93 22.93 0 0122.89 22.9 22.922 22.922 0 01-22.89 22.86v.04z" fill="#666"></path><path d="M94.1 25.47L80.57 11.94 67.1 25.41l3.32 3.32 7.86-7.86V40h4.7V20.99l7.8 7.8 3.32-3.32z" fill="#666"></path></g><defs><clipPath id="clip0_994_14916"><path fill="#fff" d="M0 0h107.81v94.34H0z"></path></clipPath></defs></svg>
              {isDragActive ? (
                <Typography variant="h6">Drop the files here ...</Typography>
              ) : (
                <Typography variant="h6">
                  Drag and drop <br /> your file anywhere here
                </Typography>
              )}
              <Typography variant="body1" style={{ marginTop: '10px' }}>
                OR
              </Typography>
              <CustomButton
                onClick={() => fileInputRef.current.click()}
                loading={loading}
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  display: 'inline-block',
                  fontSize: '14px',
                  fontWeight: 500,
                  marginTop: '20px',
                  padding: '15px 25px',
                  width: 'auto',
                }}
              >
                CHOOSE A FILE
              </CustomButton>
            </Box>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ImageSearchModal;